export type { AvatarProps } from "@components/contracts/Avatar.types";
export { CelebrationAvatar } from "./Avatar.adapter";
